import styled from '@emotion/styled'

import { mediaMax, mediaMin } from '@/styles/mixins'

export const Container = styled.div`
  position:relative;
  display: flex;
  width: 100%;
  max-width: 120rem;
  margin: 4rem auto;
  padding: 0 15px;
  flex-direction: column;
  align-items: center;



  ${mediaMin.xl} {
    max-width: 85vw;
  }

  ${mediaMax.md} {
    padding: 0 10vw;
  }

  ${mediaMax.xs} {
    width: 100%;
    padding: 0;
    margin: 3.2rem auto;
  }
`

export const PlayerContainer = styled.div`
  position: relative;
  aspect-ratio: 16 / 9;
  height: 100%;
  width: ${({ isLarge }) => isLarge ? '100%' : '60%'};
  overflow: hidden;
  clear: both;

  ${({ isLarge }) => isLarge
? ''
: `
  ${mediaMax.md} {
    width: 100%;
  }
  `};
`

export const PlayerVideo = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`
